<template>
  <div class="w-full max-w-7xl mx-auto px-[4vw] pb-12">

    <Head>
      <Title>{{ post?.meta?.title }} - BokaBord.se</Title>
      <Meta name="description" :content="post?.meta?.description" />
      <Meta name="og:image" :content="post?.meta?.image" />
    </Head>

    <!-- <div class="debug">
      title: {{ post.title }}
      <br>
      related: {{ relatedPosts?.length }}
      <br>
      relatedRestaurants: {{ relatedRestaurants?.length }}
      <br>
      route.path: {{ route.path }} 
      <br>
      city: {{ city }}
    </div> -->

    <div class="mt-2 lg:mt-8 grid gap-2">
      <Blocks :blocks="post?.blocks" />
    </div>

    <div class="grid gap-4 mt-8" v-if="relatedPosts?.length && category">
      <!-- <h2 class="font-bold" v-html="$t('shared.morePosts')" /> -->
      <!-- <DevPosts :posts="relatedPosts" /> -->
      <AtomBlockHeader :heading="$t('shared.morePosts')" />
      <div class="grid sm:grid-cols-2 xl:grid-cols-3 gap-x-4 gap-y-8 md:gap-x-8 md:gap-y-10"
        v-if="relatedPosts?.length">
        <div v-for="post in relatedPosts?.slice(0, 6)" :key="post.id">
          <NuxtLink :to="post.path" class="block">
            <PostsCard :post="post" />
          </NuxtLink>
        </div>
      </div>
    </div>

    <div class="grid gap-4 mt-8" v-if="relatedRestaurants?.length && category">
      <!-- <h2 class="font-bold" v-html="$t('shared.moreRestaurants')" /> -->
      <!-- <DevRestaurants :restaurants="relatedRestaurants" /> -->
      <AtomBlockHeader :heading="$t('shared.moreRestaurants')" />
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" v-if="relatedRestaurants?.length">
        <div v-for="restaurant, rKey in relatedRestaurants" :key="restaurant.id">
          <NuxtLink :to="{ name: 'restaurants-slug', params: { slug: restaurant.slug } }">
            <RestaurantsCard :position="rKey + 1" :restaurant="restaurant" />
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()
const app = useAppStore()
const fat = useFatStore()

// Fetch post, save as key 'post'
const { data: post } = await useFetch(`/posts${route.path}`, {
  key: `post-${route.path}`,
  baseURL: useEnv('cmsBase'),
})

// Use config from app store to get category
const category = computed(() => app.categories?.find(cat => cat.slug === route.params.all[0]))

// Get city from tags
const city = computed(() => {
  if (!post.value?.tags || !app.cities) return null
  return app.cities.find(city => post.value?.tags?.some(tag => tag.slug === city.slug))
})

// Prevent query param for paged
if (route.query?.paged) {
  navigateTo({ query: { ...route.query, paged: undefined } }, { redirectCode: 301 })
}

// Redirect if path don't match API path
if (post.value?.id && post.value.path !== route.path) {
  navigateTo({ path: post.value.path }, { redirectCode: 301 })
}

// Show 404 if no Post ID is found
if (!post.value?.id) {
  throw createError({
    statusCode: 404,
    message: 'not found',
    fatal: true
  })
}

// Get related posts
const relatedPosts = computed(() => post.value?.relatedPosts)

// Get related posts
const relatedRestaurants = computed(() => post.value?.relatedRestaurants)

const blocks = computed(() => post.value?.blocks || [])

const author = blocks.value.find(block => block.name === 'author')?.data?.user;
const restaurantReviewBlocks = blocks.value.filter(block => block.name === "restaurant_reviews") ?? [];

// Update FAT city ID (if not set), and restaurant ID's in FAT 
onMounted(() => {
  if (!fat.cityId) {
    fat.cityId = city.value?.id
  }

  fat.restaurantIds = post?.value?.blocks
    ?.filter(block => ['restaurants', 'promo'].includes(block?.name))
    ?.map(block => block?.data?.restaurants)
    ?.flat()
    ?.map(restaurant => restaurant?.restaurant?.id)
    ?.filter(id => id) || []
})

useGuideItemStructuredData(post.value, author, restaurantReviewBlocks)
</script>